var map = {
	"./11.svg": 5385,
	"./12.svg": 986,
	"./13.svg": 8827,
	"./14.svg": 3383,
	"./15.svg": 1397,
	"./16.svg": 150,
	"./17.svg": 7271,
	"./18.svg": 704,
	"./21.svg": 4480,
	"./22.svg": 1523,
	"./23.svg": 6882,
	"./24.svg": 813,
	"./25.svg": 1340,
	"./26.svg": 367,
	"./27.svg": 6638,
	"./28.svg": 5513,
	"./31.svg": 4311,
	"./32.svg": 9748,
	"./33.svg": 7733,
	"./34.svg": 8634,
	"./35.svg": 7451,
	"./36.svg": 1912,
	"./37.svg": 310,
	"./38.svg": 7486,
	"./41.svg": 1262,
	"./42.svg": 3357,
	"./43.svg": 4812,
	"./44.svg": 2467,
	"./45.svg": 9426,
	"./46.svg": 1169,
	"./47.svg": 6368,
	"./48.svg": 3287,
	"./51.svg": 9485,
	"./52.svg": 1134,
	"./53.svg": 9567,
	"./54.svg": 3680,
	"./55.svg": 9633,
	"./61.svg": 6100,
	"./62.svg": 7607,
	"./63.svg": 486,
	"./64.svg": 5721,
	"./65.svg": 7800,
	"./71.svg": 2344,
	"./72.svg": 1128,
	"./73.svg": 281,
	"./74.svg": 3398,
	"./75.svg": 6199,
	"./81.svg": 7570,
	"./82.svg": 2609,
	"./83.svg": 368,
	"./84.svg": 6255,
	"./85.svg": 7326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7989;